/** If you wish to mount a larger rectangle that then active camera rectangle change the multiplier to a positive value
 * Mount Window Side = Camera Window Side + 2 * ( 1 + multiplier) */

export const CAMERA_DEFAULT_Z = 2;
export const PLANE_DEFAULT_Z = 0; // The plane on which all content is displayed.
export const PAN_VELOCITY_FACTOR = 200;
export const CAMERA_DEFAULT_ZOOM = 1; // (maybe should be called CAMERA_NO_ZOOM; don't change this value)

export const CAMERA_MIN_ZOOM = 0.25;
export const CAMERA_MAX_ZOOM = 1;
export const ZOOM_SPAN_SEGMENT = (CAMERA_MAX_ZOOM - CAMERA_MIN_ZOOM) / 4; // slices of the zoom area span
export const ZOOM_STEP = ZOOM_SPAN_SEGMENT; // always zoom in/out a bit more, so we don't rest on the segment boundaries
export const SUPPRESS_PRODUCT_DISPLAY_ZOOM_LIMIT =
  CAMERA_MIN_ZOOM + ZOOM_SPAN_SEGMENT * 1.1;
export const SUPPRESS_BACKGROUND_DISPLAY = CAMERA_MIN_ZOOM * 1.1; // A little bit higher than min zoom

export const SHOP_FLOOR_CAMERA_DEFAULT_ZOOM =
  CAMERA_MAX_ZOOM - ZOOM_SPAN_SEGMENT * 2; // start on the shop floor zoomed out a couple of notches
